<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="block">
        <p class="title">热区模块</p>
        <el-tabs v-model="activeName">
          <el-tab-pane label="内容管理" name="contentManager">
            <div class="hotmap-list-container">
              <div class="fleft">
                <el-button type="success" @click='addHotMap'>新增</el-button>
              </div>
              <div v-if="count > 0" class="clearfix fright" style="margin-bottom: 20px;">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="pageSize"
                  layout="total, prev, pager, next, jumper"
                  :total="count">
                </el-pagination>
              </div>
              <table class="table is-bordered">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>图片</th>
                  <th>标题以及访问量</th>
                  <th>状态</th>
                  <th>排序号</th>
                  <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr class="list-cell" v-for="(item, index) in hotMapList">
                  <td>
                    {{item.contentId}}
                    <span class="tag is-success" v-if="item.statusTag==0">开放中</span>
                    <span class="tag is-black" v-if="item.statusTag==1">未开始</span>
                    <span class="tag is-light" v-if="item.statusTag==2">已结束</span>
                    <span class="tag is-light" v-if="item.statusTag==3">已关闭</span>
                  </td>
                  <td>
                    <image-component :image="item.image.image" :width='150'></image-component>
                  </td>
                  <td>
                    <p class="content-title title">标题:{{item.title}}</p>
                    <p class="white-space" v-if='item.stats.length'>访问量:{{item.stats.join('/')}}</p>
                  </td>
                  <td>
                    <div class="time">{{item.startTime | formatDate('yyyy-MM-dd hh:mm:ss')}} ~ {{item.endTime | formatDate('yyyy-MM-dd hh:mm:ss')}} </div>
                  </td>
                  <td>
                    <div class="sort-wrap">排序号</br>
                      <input class="input width-1" v-model="item.sort" @change="sort(item.contentId, item.sort)">
                    </div>
                  </td>
                  <td>
                    <p class='button-wrap'>
                      <el-button type="success" @click="goEdit(item)">编辑</el-button>
                    </p>
                    <p>
                      <el-button type="danger" @click="deleteModuleContent(item.contentId, index)">删除</el-button>
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-if="count > 0" class="clearfix fright">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="count">
                  </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="模块设置" name="moduleSetting">
            <div>
              <div class="margin-top-left-20">
                <p class="title">
                  <el-checkbox v-model="moduleSetting.showTitle">是否展示标题</el-checkbox>
                </p>
                <div class="block width-2">
                  <input class="input" type="text" v-model='moduleSetting.title'>
                </div>
                <p class="title">显示 "查看全部" <i>(客户端不需要展示则留空)</i></p>
                <div class="block width-2">
                  <input class="input" type="text" v-model='moduleSetting.moreTitle'>
                </div>
                <p class="title">"查看全部" 跳转链接</p>
                <div class="block cyzs-w-400">
                  <custom-link :link='moduleSetting.moreLink' @update:link="val => { moduleSetting.moreLink = val }"></custom-link>
                </div>
                <p class="block title">显示状态</p>
                <p class="block width-2">
                  <el-radio class="radio" v-model="moduleSetting.status" :label="1">开启</el-radio>
                  <el-radio class="radio" v-model="moduleSetting.status" :label="0">关闭</el-radio>
                </p>
                <div class="slider-wrap">
                  <p class="title">
                    <span>与上一模块间距（px)</span>
                    <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                      <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                    </el-tooltip>
                  </p>
                  <p>
                    <el-slider v-model="moduleSetting.marginTop" :max="400" :show-input="true"></el-slider>
                  </p>
                </div>
                <div v-if="routerName == 'discovery'" class="slider-wrap">
                  <div class="title">是否展示底部分割线</div>
                  <div class="block">
                    <label><input type="radio" :value="1" v-model="moduleSetting.isShowTopLine" name="isShowTopLine">是</label>
                    <label><input type="radio" :value="0" v-model="moduleSetting.isShowTopLine" name="isShowTopLine">否</label>
                  </div>
                </div>
              </div>
              <div class="margin-top-left-20">
                <el-button type="success" @click='doSaveModule'>保存</el-button>
                <el-button v-if='moduleSetting.status==2' @click='archiveModule(moduleSetting.status)'>还原模块</el-button>
                <el-button v-if='currentFashionMenu.moduleId && moduleSetting.status!=2' @click='archiveModule(moduleSetting.status)'>归档模块</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
  import CustomLink from 'COMMON/DefinedLink';
  import { mapState, mapActions } from 'vuex';

  export default {
    data() {
      return {
        hotMapList: [],
        showEdit: false,
        currentContentId: 0,
        count: 0,
        currentPage: 1,
        pageSize: 10,

        moduleSetting: {
          title: '',
          showTitle: false,
          status: 1,
          moreTitle: '',
          moreLink: '',
          marginTop: 0,
		  isShowTopLine: 1
        },
        moduleSettingSelected: false,
        activeName: 'contentManager',
		routerName: ''
	  }
    },
    mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page*1;
      }
      if (this.currentFashionMenu.moduleType == -1) {
        this.setCurrentFashionMenuByVuex({
          type: this.$route.query.type,
          moduleType:this.$route.query.moduleType,
          moduleId:this.$route.query.moduleId
        })
      } else {
        this.init()
      }
	  this.routerName = this.$route.name

	},
    watch: {
      currentFashionMenu: {
        handler(val) {
          this.init()
        },
        deep: true
      }
    },
    computed: {
      marginTopPer () {
        return this.moduleSetting.marginTop + 'px'
      },
      ...mapState({
        currentFashionMenu: state => state.currentFashionMenu
      }),
    },
    methods: {
      init() {
        this.showEdit = false
        this.moduleSettingSelected = !this.currentFashionMenu.moduleId
        if (this.moduleSettingSelected) {
          this.activeName = 'moduleSetting'
          this.moduleSetting = {
            title: '',
            showTitle: false,
            status: 1,
            moreTitle: '',
            moreLink: '',
            marginTop: 0,
			isShowTopLine: 1
          }
          this.hotMapList = []
          this.count = 0
        } else {
          this.activeName = 'contentManager'
          this.getModuleList()
          this.getModule();
        }
      },
      sort(contentId, sort) {
        let params = {
          contentId: contentId,
          sort: sort
        }
        HttpRequest.get("/admin.php?method=fashion.doSaveModuleContentSort", params).then((response) => {
          if (response.data.success) {
            this.$message('保存成功')
          }
        })
      },
      getModuleList() {
        if (this.currentFashionMenu.moduleId) {
          let params = {
            type: this.currentFashionMenu.type,
            moduleId: this.currentFashionMenu.moduleId,
            page: this.currentPage,
            pageSize: this.pageSize
          }
          HttpRequest.get("/admin.php?method=fashion.getModuleContentList", params).then((response) => {
            this.count = response.data.count
            if (response && response.data && response.data.list) {
              this.hotMapList = response.data.list
            } else {
              this.hotMapList = []
            }
          })
        }
      },
      handleCurrentChange(page) {
        if(this.currentPage!==page){
          this.currentPage=page;
          this.getModuleList()
        }
      },
      getModule() {
        HttpRequest.get("/admin.php?method=fashion.getModule", {moduleId: this.currentFashionMenu.moduleId}).then((response) => {
          this.moduleSetting.title = response.data.title
          this.moduleSetting.showTitle = response.data.showTitle == 1
          this.moduleSetting.status = response.data.status
          this.moduleSetting.moreTitle = response.data.moreTitle
          this.moduleSetting.moreLink = response.data.moreLink
          this.moduleSetting.marginTop = response.data.marginTop * 2
          this.moduleSetting.isShowTopLine = response.data.isShowTopLine ? 1 : 0
        })
      },
      addHotMap() {
        if (this.currentFashionMenu.moduleId) {
          this.$router.push({
            name: 'hotMapEdit',
            query: this.getQuery()
          })
        } else {
          this.$message('请先完成模块设置')
        }
      },
      getQuery(query = {}) {
        let params = {
          type: this.$route.query.type,
          moduleType:this.$route.query.moduleType,
          moduleId:this.$route.query.moduleId 
        }
        return Object.assign(query, params)
      },
      doSaveModule() {
        if(this.moduleSetting.moreTitle){
          if(!this.moduleSetting.moreLink){
            return
          }
        }else{
          this.moduleSetting.moreLink = "";
        }

        let params = Object.assign({}, this.currentFashionMenu, this.moduleSetting, {showTitle: this.moduleSetting.showTitle ? 1 : 0,isShowTopLine: this.moduleSetting.isShowTopLine ? 1 : 0, marginTop: this.moduleSetting.marginTop / 2})
        HttpRequest.post("/admin.php?method=fashion.doSaveModule", params).then((response) => {
          if (response.data.success) {
            setTimeout(() => {
              this.commitFashionMenuUpdate(true)
            }, 2000)
            this.$message('保存成功')
          }
        })
      },
      archiveModule(status) {
        let params = {
          moduleId: this.currentFashionMenu.moduleId,
          actionType: 0
        }
        if (status == 2) {
          params.actionType = 1
        } else  {
          params.actionType = 0
        }
        HttpRequest.get("/admin.php?method=fashion.archiveModule", params).then((response) => {
          if (response.data.success) {
            setTimeout(() => {
              this.commitFashionMenuUpdate(true)
            })
            this.$message('操作成功')
          }
        })
      },
      editModuleContent(contentId = 0) {
        this.currentContentId = contentId
        this.showEdit = true
      },
      deleteModuleContent(contentId, index) {
        let params = {
          contentId: contentId
        }
        if (confirm('确定删除?')) {
          HttpRequest.get("/admin.php?method=fashion.deleteModuleContent", params).then((response) => {
            if (response.data.success) {
              this.hotMapList.splice(index, 1)
            }
          })
        }
      },
      goEdit(item) {
        this.$router.push({
          name: 'hotMapEdit',
          query: Object.assign({ page: this.currentPage },this.getQuery({ contentId: item.contentId,}))
        })
      },
      ...mapActions([
        'commitFashionMenuUpdate', 'setCurrentFashionMenuByVuex'
      ]),
    },
    components: { CustomLink}
  }

</script>

<style lang="less" scoped>
  .hotmap-list-container {
    .list-cell{
      .title{
        margin-bottom: 20px;
        padding: 0;
      }
      .time{
        margin-bottom: 20px;
        width: 150px;
        white-space: normal;
      }

    }
    .button-wrap {
      margin-bottom: 10px;
    }
  }

  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
  .margin-top-left-20{
    margin: 20px 0 0 20px;
  }
  .slider-wrap{
    width: 400px;
    margin-top: 40px;
    .tooltip-value{
      margin-left: 20px;
    }
    .input-slider{
      margin-top: 30px;
    }
  }
  .content-title{
    white-space: normal;
    line-height: 1.2;
    display: inline-block;
  }
  .cursor-point {
    cursor: pointer;
  }
</style>
